import React from 'react';
import clsx from 'clsx';

export const ScrollArea = ({ children, className = '', style = {} }) => {
  return (
    <div
      className={clsx(
        'overflow-auto rounded-xl scrollbar-thin scrollbar-thumb-white/20 scrollbar-track-transparent hover:scrollbar-thumb-white/40 transition-all',
        className
      )}
      style={{
        WebkitOverflowScrolling: 'touch',
        ...style,
      }}
    >
      {children}
    </div>
  );
};
